module.exports = new __parcel__URL__("LivePagesInProductPromptBannerImage.a00fdba6.svg").toString();